import { render } from "./Investments.vue?vue&type=template&id=a341fb2e&scoped=true"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"

import "./Investments.vue?vue&type=style&index=0&id=a341fb2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a341fb2e"]])

export default __exports__